// NPM
import React, { useState, useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// Services
import apiService from "services/apiService";
import renderService from "services/renderService";

function ElectionOutcome() {
  // State
  const [seatShareData, setSeatShareData] = useState({});
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const region = useSelector((state) => state.region.value);
  const parties = useSelector((state) => state.parties.value);
  const partyIds = parties.map((p) => p.id);

  const loadData = async () => {
    const response = await fetch(apiService.apiURL("seat_share"));
    const jsonData = await response.json();
    setSeatShareData(jsonData);
  };

  // Hooks
  useEffect(() => loadData(), []);

  // Short-circuit
  if (!renderService.canRender([seatShareData, region, parties])) {
    return null;
  }

  // Make sure we're only rendering data that can be matched to a party
  const filteredSeatShareData = _.chain(seatShareData)
    .filter((ssd) => _.includes(partyIds, ssd.party))
    .sortBy((ssd) => {
      if (ssd.median === "NA") return -1;
      return parseInt(ssd.median);
    })
    .reverse()
    .value();

  const mostSeatData = filteredSeatShareData[0];
  const mostSeatParty = parties.find((p) => p.id === mostSeatData?.party);

  const { title, description } = _.get(
    campaignConfig,
    `sections.ElectionOutcome`,
    {},
  );

  const [titlePart1, titlePart2] = title.split("{{PARTY_NAME}}");

  return (
    <div className="ElectionOutcome">
      <p className="ElectionOutcome__description">{description}</p>

      <h2 className="ElectionOutcome__title">
        {titlePart1}
        <span
          className="ElectionOutcome__party"
          style={{
            color: `${mostSeatParty?.color}`,
          }}
        >
          {/* FIXME: Add a proper designation to avoid adding an "s" to the party name when re-deploying the backend */}
          {mostSeatParty?.friendlyName}s
        </span>
        {titlePart2}
      </h2>
    </div>
  );
}

export default ElectionOutcome;
